import React from 'react';
import { DonorInfoStep } from './DonorInfoStep.jsx';
import { AddressStep } from './AddressStep.jsx';
import { PaymentStep } from './PaymentStep.jsx';
import { ChargeResultStep } from './ChargeResultStep.jsx';
import { ConfirmationStep } from './ConfirmationStep.jsx';

/**
 * Props every step takes. Exported because a root also renders steps of its own
 * (the amount ladder, the cart) and they expect the same shape.
 */
export function buildStepProps({ config, flow, isInline, isPreview, onClose }) {
  return {
    config,
    formData: flow.formData,
    onChange: flow.handleChange,
    onNext: flow.handleNext,
    onBack: flow.handleBack,
    onClose,
    isInline,
    isPreview,
    canGoBack: flow.currentStepIndex > 0
  };
}

/**
 * Everything from "who is donating" to "thank you" — identical whether the
 * amount came from the ladder or from the picker's cart. Renders nothing for
 * steps a root owns itself.
 */
export function CheckoutSteps({ config, flow, isInline, isPreview, onClose }) {
  const stepProps = buildStepProps({ config, flow, isInline, isPreview, onClose });
  const { currentStep, isSubmitting } = flow;

  return (
    <>
      {currentStep === 'donorInfo' && (
        <DonorInfoStep
          {...stepProps}
          onNext={isPreview ? flow.handleNext : flow.submitDonor}
          isSubmitting={isSubmitting}
        />
      )}
      {currentStep === 'address' && (
        <AddressStep
          {...stepProps}
          onNext={isPreview ? flow.handleNext : flow.handleAddressSubmit}
          onSkip={flow.handleNext}
          isRequired={Boolean(config.Behaviour.Address?.Required)}
          isSubmitting={isSubmitting}
        />
      )}
      {currentStep === 'addressToBoleto' && (
        <AddressStep
          {...stepProps}
          onNext={isPreview ? flow.handleNext : flow.handleAddressSubmit}
          isRequired
          isSubmitting={isSubmitting}
        />
      )}
      {currentStep === 'addressAfterCharge' && (
        <AddressStep
          {...stepProps}
          onNext={isPreview ? flow.handleNext : () => flow.submitDonor()}
          onSkip={flow.handleNext}
          isRequired={false}
          intro="Quase lá! Se quiser, adicione seu endereço — é opcional."
          isSubmitting={isSubmitting}
        />
      )}
      {currentStep === 'payment' && (
        <PaymentStep
          {...stepProps}
          onSubmit={isPreview ? flow.handleNext : flow.handlePaymentSubmit}
          isSubmitting={isSubmitting}
        />
      )}
      {currentStep === 'chargeResult' && (
        <ChargeResultStep {...stepProps} onRetryPayment={flow.handleRetryPayment} />
      )}
      {currentStep === 'confirmation' && (
        <ConfirmationStep
          config={config}
          formData={flow.formData}
          onClose={onClose}
          showClose={!isInline}
        />
      )}
    </>
  );
}
